import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const TicketBookingEdit = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="package-form-modal-title"
      centered
      
    >
      <Modal.Header closeButton>
        <Modal.Title id="package-form-modal-title">Update Bookings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formFile">
                <Form.Label>Upload Image</Form.Label>
                <Form.Control type="file" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formPackageName">
                <Form.Label>Flight Number</Form.Label>
                <Form.Control type="text" placeholder="Enter Flight Number" />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
            <Form.Group controlId="formPackageName">
                <Form.Label>Departure</Form.Label>
                <Form.Control type="text" placeholder="Enter Departure" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formPackageName">
                <Form.Label>Arrival</Form.Label>
                <Form.Control type="text" placeholder="Enter Arrival" />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
             <Col md={6}>
              <Form.Group controlId="formPrice">
                <Form.Label>Booking Type</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Booking Type"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
    <Form.Group controlId="formDateTime">
      <Form.Label>Date and Time</Form.Label>
      <Form.Control type="datetime-local" />
    </Form.Group>
    </Col>
          </Row>

          <Row className="mb-3">
         
           
            <Col md={6}>
              <Form.Group controlId="formActions">
                <Form.Label>Actions</Form.Label>
                <Form.Select>
                  <option>Completed</option>
                  <option>Processing</option>
                  <option>On Hold</option>
                  <option>Pending</option>
                  <option>Cancelled</option>
                  <option>Refund Initiated</option>
                  <option>Refund Completed</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{background:"#359383", border:"0px solid black"}}onClick={handleClose}>
          Close
        </Button>
        <Button style={{background:"#212d60", border:"0px solid black"}}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketBookingEdit;
